import ColumnTipHeader from '#/modules/commonComponents/table/ColumnTipHeader';
import { DocumentStatusBadge } from '#/modules/commonComponents/badge';
import { STOCK_RECEIPT_RECEIPT_DATE_TIP } from '#/modules/imsMgmt/receipts/stockReceipt/helper/receiptDateTip';
import { formatDateOrDash } from '#/utils/date';

/** Block A：僅狀態 */
export const stockReceiptSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <DocumentStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位（不含狀態／操作） */
export const stockReceiptSideMsgDetailBlock = {
  fields: [
    { label: '進貨單號', value: 'receiptNo' },
    { label: '倉別', value: (row) => row.warehouse?.name ?? '-' },
    { label: '供應商', value: (row) => row.supplier?.name ?? '-' },
    {
      key: 'receiptDate',
      label: '製造商開單日',
      render: (row) => (
        <div className="side_msg-row">
          <h3>
            <ColumnTipHeader label="製造商開單日" tip={STOCK_RECEIPT_RECEIPT_DATE_TIP} />
          </h3>
          <p>{formatDateOrDash(row?.receiptDate)}</p>
        </div>
      ),
    },
    {
      label: '事由',
      value: 'issueReason',
    },
    { label: '備註', value: 'remark' },
  ],
};

/** 相容：狀態 + 其餘（操作由 SideMsg 薄包插入） */
export const stockReceiptSideMsgBlocks = [
  stockReceiptSideMsgStatusBlock,
  stockReceiptSideMsgDetailBlock,
];
